import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import Badge from "@atlaskit/badge";
import SearchIcon from "@atlaskit/icon/glyph/search";
import FilterIcon from "@atlaskit/icon/glyph/filter";
import ChevronLeftIcon from "@atlaskit/icon/glyph/chevron-left";
import ChevronRightLargeIcon from "@atlaskit/icon/glyph/chevron-right-large";
import ChevronLeftLargeIcon from "@atlaskit/icon/glyph/chevron-left-large";
import ArrowDownIcon from "@atlaskit/icon/glyph/arrow-down";
import ExcelSpreadsheet16Icon from "@atlaskit/icon-file-type/glyph/excel-spreadsheet/16";
import Document16Icon from "@atlaskit/icon-file-type/glyph/document/16";
import Button, { ButtonGroup } from "@atlaskit/button";
import Lozenge from "@atlaskit/lozenge";
import { TableWrapper, createCells, createHead } from "../Table/WrapperRestore";
import ProgressTrack from "../../../components/Shared/ProgressTracker/ProgressTrack";
import Select, { components, CheckboxSelect } from "@atlaskit/select";
import Popup from "@atlaskit/popup";
import Textfield from "@atlaskit/textfield";
import Form, { Field, ErrorMessage } from "@atlaskit/form";
import BitbucketCloneIcon from "@atlaskit/icon/glyph/bitbucket/clone";

import styles from "./RestorePreview.module.css";
import {
  issueTypeSelectBackColor,
  eventTypeBackColor,
  sortAlhabeticallyname,
  sortAlhabeticallyproject,
} from "../../../helpers/helpers";

const brandColor = "#253858";
const textColor = "#F4F5F7";

const CustomStyle = (val) => {
  return {
    control: (base) => ({
      ...base,
      backgroundColor:
        val && val.length !== 0 ? brandColor : base.backgroundColor,

      ":active": {
        backgroundColor:
          val && val.length !== 0 ? brandColor : base.backgroundColor,
      },
      ":hover": {
        backgroundColor:
          val && val.length !== 0 ? brandColor : base.backgroundColor,
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: val ? textColor : base.backgroundColor,
    }),
    multiValue: (base) => ({
      ...base,
      color: val ? textColor : base.backgroundColor,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: val ? textColor : base.backgroundColor,
    }),
    valueContainer: (base) => ({
      ...base,
      color: val && val !== "" ? textColor : base.backgroundColor,
    }),
    input: (base) => ({
      ...base,
      width: "max-content",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "150px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#F4F5F7" : undefined,
        color: "black",
      };
    },
  };
};
const formatOptionLabel = ({ name }) => (
  <Lozenge
    style={{
      backgroundColor: issueTypeSelectBackColor(name),
      color: "#000",
    }}
    isBold
  >
    {name}
  </Lozenge>
);

const formatOptionStatus = ({ name }) => (
  <Lozenge
    style={{
      backgroundColor: eventTypeBackColor(name),
      color: "#000",
    }}
    isBold
  >
    {name}
  </Lozenge>
);

const SingleValue = (props) =>
  // <components.SingleValue {...props}>
  props.data.projectName ? (
    <strong>Projects: {props.data.projectName}</strong>
  ) : (
    <strong>Issue Type: {props.data.name}</strong>
  );
// </components.SingleValue>
// const MultiValue = ({ children, hasValue, ...props }) => {
//   if (!hasValue) {
//     return (
//       <components.ValueContainer {...props}>
//         {children}
//       </components.ValueContainer>
//     );
//   }

//   const chipsLimit = 1;
//   const [chips, otherChildren] = children;
//   const overflowCounter = chips.slice(chipsLimit).length;
//   const displayChips = chips.slice(
//     overflowCounter,
//     overflowCounter + chipsLimit
//   );
//   return (
//     <components.ValueContainer {...props}>
//       <strong>Issue Status: </strong> {displayChips}
//       {overflowCounter > 0 ? (
//         <Badge appearance="primary"> +{overflowCounter} </Badge>
//       ) : (
//         ""
//       )}
//       {otherChildren}
//     </components.ValueContainer>
//   );
// };

// const ValueContainer = ({ children, ...props }) => {
//   let [values, input] = children;

//   if (Array.isArray(values)) {
//     const { length } = values;
//     const val = () => values[length - 1].props.data.name;
//     const otherCount = length - 1;
//     const BadgeNumber =
//       otherCount > 0 ? <Badge appearance="primary"> +{otherCount} </Badge> : "";
//     values = `${val()}`;
//     return (
//       <components.ValueContainer {...props}>
//         {values ? <strong>Issue Status:&nbsp; </strong> : ""}
//         {values}
//         &nbsp;
//         {BadgeNumber}
//         {input}
//       </components.ValueContainer>
//     );
//   } else
//     return (
//       <components.ValueContainer {...props}>
//         {values}
//         {input}
//       </components.ValueContainer>
//     );
// };

const MultiValue = ({ getValue, index }) => {
  const otherCount = getValue().length - 1;
  const BadgeNumber =
    otherCount > 0 ? <Badge appearance="primary"> +{otherCount} </Badge> : "";
  const display = `${getValue()[getValue().length - 1].name}`;
  return (
    !index && (
      <>
        <strong>
          Issue Status : {display}
          &nbsp; {BadgeNumber}
        </strong>
      </>
    )
  );
};

const RestorePreview = (props) => {
  //const [totalPages, setTotalPages] = useState(0);
  const [newFilterData, setNewFilterData] = useState(props.filterData);
  const [isOpen, setIsOpen] = useState(false);
  const validateSummary = useRef("");
  const validateDescription = useRef("");
  useEffect(() => {
    //const setData = async () => {
    //   setTotalPages(
    //     // Math.ceil(props.snapshotCount / props.pageData.pagination.size)
    //     Math.ceil(props.snapshotCount / pageSize)
    //   );
    // };
    // setData();
  }, [props.pageNumber]);

  const rows = createCells(
    props.previewData,
    props.handleCheckboxCheck,
    props.tempCheckedItems,
    props.checkedIssues
  );
  const head = createHead(
    true,
    props.handleCheckboxCheckAll,
    props.isLoading,
    props.globalCheckState
  );
  return (
    <div className={styles.mainContainer}>
      <div className={styles.tracker}>
        <div className={styles.trackerItem}>
          <ProgressTrack data={props.progressTrack} />
        </div>
      </div>
      <hr />
      <div className={styles.filterscontainer}>
        <Form
          onSubmit={(data) => {
            props.handleMapField(newFilterData);
          }}
          isDisabled={props.isLoading}
        >
          {({ formProps }) => (
            <form {...formProps} id="my-form">
              <div className={styles.infoContainer}>
                <div className={styles.infoItem} style={{ width: "165px" }}>
                  <Field
                    name="searchText"
                    defaultValue={props.formStateData.searchText}
                    // validate={async (value) => {
                    //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                    //   if (regexp.test(value)) {
                    //     return undefined;
                    //   } else {
                    //     return "Please Enter Valid Search Text";
                    //   }
                    // }}
                  >
                    {({ fieldProps, error }) => (
                      <>
                        <Textfield
                          elemAfterInput={
                            <div
                              style={{
                                paddingRight: "6px",
                                lineHeight: "100%",
                              }}
                            >
                              <SearchIcon
                                size="small"
                                borderColor="transparent"
                              />
                            </div>
                          }
                          placeholder="Search Summary"
                          {...fieldProps}
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              searchText: value.target.value,
                            });
                            setNewFilterData({
                              ...newFilterData,
                              searchText: value.target.value,
                            });
                            fieldProps.onChange(value);
                            const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");

                            if (regexp.test(value.target.value)) {
                              validateSummary.current = "";
                            } else {
                              validateSummary.current = "error";
                            }
                          }}
                        />
                        {error ? (
                          <ErrorMessage>{error}</ErrorMessage>
                        ) : validateSummary.current === "error" ? (
                          <ErrorMessage>Please enter a valid text</ErrorMessage>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className={styles.infoItem} style={{ width: "165px" }}>
                  <Field
                    name="searchDescription"
                    defaultValue={props.formStateData.searchDescription}
                    // validate={async (value) => {
                    //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                    //   if (regexp.test(value)) {
                    //     return undefined;
                    //   } else {
                    //     return "Please Enter Valid Search Description";
                    //   }
                    // }}
                  >
                    {({ fieldProps, error }) => (
                      <>
                        <Textfield
                          elemAfterInput={
                            <div
                              style={{
                                paddingRight: "6px",
                                lineHeight: "100%",
                              }}
                            >
                              <SearchIcon
                                size="small"
                                borderColor="transparent"
                              />
                            </div>
                          }
                          placeholder="Search Description"
                          {...fieldProps}
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              searchDescription: value.target.value,
                            });
                            setNewFilterData({
                              ...newFilterData,
                              searchDescription: value.target.value,
                            });
                            fieldProps.onChange(value);
                            const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");

                            if (regexp.test(value.target.value)) {
                              validateDescription.current = "";
                            } else {
                              validateDescription.current = "error";
                            }
                          }}
                        />
                        {error ? (
                          <ErrorMessage>{error}</ErrorMessage>
                        ) : validateDescription.current === "error" ? (
                          <ErrorMessage>Please enter a valid text</ErrorMessage>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className={styles.infoItem}>
                  <Field
                    aria-required={true}
                    name="project"
                    id="project"
                    isRequired
                    isDisabled={props.projects.length === 0 ? true : false}
                    defaultValue={props.formStateData.project}
                    validate={async (value) => {
                      if (value) {
                        return undefined;
                      }

                      return new Promise((resolve) =>
                        setTimeout(resolve, 300)
                      ).then(() => "Please select a project");
                    }}
                  >
                    {({ fieldProps: { id, ...rest } }) => (
                      <>
                        <Select
                          styles={CustomStyle(props.formStateData.project)}
                          components={{ SingleValue }}
                          noOptionsMessage={({ inputValue }) =>
                            !inputValue ? "No Project Options" : ""
                          }
                          getOptionLabel={(option) => option.projectName}
                          getOptionValue={(option) => option.projectId}
                          id={`${id}-select`}
                          options={sortAlhabeticallyproject(props.projects)}
                          placeholder="Select Project"
                          {...rest}
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              issueType: null,
                              status: null,
                              project: value,
                            });
                            rest.onChange({
                              projectName: value.projectName,
                              projectId: value.projectId,
                            });
                            setNewFilterData({
                              ...newFilterData,
                              projectId: value.projectId,
                              issueTypeId: "",
                              issueStatusId: "",
                            });
                            props.handleProjectData(value);
                          }}
                        />
                      </>
                    )}
                  </Field>
                </div>
                <div className={styles.infoItem}>
                  <Field
                    aria-required={true}
                    name="issueType"
                    id="issueType"
                    isDisabled={props.issueTypes.length === 0 ? true : false}
                    isRequired
                    defaultValue={props.formStateData.issueType}
                    validate={async (value) => {
                      if (value) {
                        return undefined;
                      }

                      return new Promise((resolve) =>
                        setTimeout(resolve, 300)
                      ).then(() => "Please select an issue type");
                    }}
                  >
                    {({ fieldProps: { id, ...rest }, error }) => (
                      <>
                        <Select
                          styles={CustomStyle(props.formStateData.issueType)}
                          noOptionsMessage={({ inputValue }) =>
                            !inputValue ? "No Issue Type Options" : ""
                          }
                          components={{ SingleValue }}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.issueTypeId}
                          id={`${id}-select`}
                          formatOptionLabel={formatOptionLabel}
                          options={sortAlhabeticallyname(props.issueTypes)}
                          placeholder="Select issue type"
                          {...rest}
                          validationState={
                            !rest.isDisabled && error ? "error" : "default"
                          }
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              issueType: value,
                            });
                            setNewFilterData({
                              ...newFilterData,
                              issueTypeId: value.issueTypeId,
                            });

                            rest.onChange(value);
                          }}
                        />
                        {!rest.isDisabled && error && (
                          <ErrorMessage>{error}</ErrorMessage>
                        )}
                      </>
                    )}
                  </Field>
                </div>

                <div className={styles.infoItem}>
                  <Field
                    aria-required={true}
                    name="status"
                    id="status"
                    defaultValue={props.formStateData.status}
                    isDisabled={props.status.length === 0 ? true : false}
                  >
                    {({ fieldProps: { id, ...rest }, error }) => (
                      <CheckboxSelect
                        styles={CustomStyle(props.formStateData.status)}
                        noOptionsMessage={({ inputValue }) =>
                          !inputValue ? "No Issue Status Options" : ""
                        }
                        formatOptionLabel={formatOptionStatus}
                        //components={{ ValueContainer }}
                        components={{ MultiValue }}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.statusId}
                        id={`${id}-select`}
                        options={sortAlhabeticallyname(props.status)}
                        placeholder="Select status"
                        isMulti
                        {...rest}
                        validationState={
                          !rest.isDisabled && error ? "error" : "default"
                        }
                        onChange={(value) => {
                          const issueStatus = value
                            ? value.map((data) => {
                                return data.statusId;
                              })
                            : [];
                          props.setFormStateData({
                            ...props.formStateData,
                            status: value,
                          });
                          setNewFilterData({
                            ...newFilterData,
                            issueStatusId: issueStatus,
                          });
                          rest.onChange(value);
                        }}
                        closeMenuOnSelect={false}
                        isSearchable={false}
                      />
                    )}
                  </Field>
                </div>

                {/* <div className={styles.infoItem}>
                  <Button
                    iconBefore={<FilterIcon size="small"></FilterIcon>}
                    style={{ marginTop: "5px" }}
                    appearance="subtle"
                    type="submit"
                    isDisabled={props.isLoading}
                  >
                    Apply filters
                  </Button>
                </div> */}
              </div>
            </form>
          )}
        </Form>

        <div className={styles.statscontainer}>
          <Button
            form="my-form"
            iconBefore={<FilterIcon size="small"></FilterIcon>}
            style={{ marginTop: "5px" }}
            appearance="default"
            type="submit"
            isDisabled={props.isLoading}
            // onClick={() => {
            //   props.handleMapField(newFilterData);
            // }}
          >
            Apply filters
          </Button>

          <div style={{ marginTop: "11px" }}>
            <strong>Selected Issues: {props.checkedIssues.length}</strong>
          </div>
        </div>
      </div>
      <div className={styles.tableContainer}>
        <TableWrapper>
          <DynamicTable
            head={head}
            rows={rows}
            rowsPerPage={undefined}
            defaultPage={1}
            loadingSpinnerSize="large"
            isLoading={props.isLoading}
            isFixedSize
            // onSetPage={(1, undefined)}
            emptyView={<strong>No data found</strong>}
          />
        </TableWrapper>

        {props.pageData.pagination.nextToken === null &&
        props.pageNumber === 1 ? (
          ""
        ) : (
          // <Pagination
          //   isDisabled={props.isLoading}
          //   pages={Array.from({ length: totalPages }).map(
          //     (currentElement, i) => i + 1
          //   )}
          //   onChange={props.onPaginationChange}
          //   // selectedIndex={props.pageData.pagination.page - 1}
          //   selectedIndex={props.pageNumber}
          // />
          <div style={{ gap: "20px" }}>
            <Button
              iconBefore={<ChevronLeftLargeIcon label="Back" size="medium" />}
              appearance="default"
              id="prevPage"
              onClick={props.getPrevData}
              isDisabled={props.isLoading || props.pageNumber === 1}
            ></Button>
            {props.pageNumber}
            <Button
              iconBefore={<ChevronRightLargeIcon label="Back" size="medium" />}
              appearance="default"
              id="nextPage"
              onClick={props.getNextData}
              isDisabled={
                props.isLoading || props.pageData.pagination.nextToken === null
              }
            ></Button>
          </div>
        )}
        <div className={styles.buttons}>
          <ButtonGroup className={styles.buttons}>
            <Button
              iconBefore={<ChevronLeftIcon label="Back" size="medium" />}
              appearance="default"
              id="backPreviewData"
              onClick={props.handlePreviewBack}
              isDisabled={props.isLoading}
            >
              Back
            </Button>

            <Popup
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              placement="bottom-start"
              content={() => (
                <div className={styles.content}>
                  <ButtonGroup appearance="subtle">
                    <Button
                      spacing="compact"
                      iconBefore={<Document16Icon label="Download JSON" />}
                      onClick={() => {
                        props.setDownloadType("json");
                        props.setShowDownloadConfirm(true);
                        // props.handleDownloadData("json");
                        setIsOpen(false);
                      }}
                    >
                      JSON
                    </Button>
                    <Button
                      spacing="compact"
                      iconBefore={
                        <ExcelSpreadsheet16Icon label="Download CSV" />
                      }
                      onClick={() => {
                        props.setDownloadType("csv");
                        props.setShowDownloadConfirm(true);
                        // props.handleDownloadData("csv");
                        setIsOpen(false);
                      }}
                    >
                      CSV
                    </Button>
                  </ButtonGroup>
                </div>
              )}
              trigger={(triggerProps) => (
                <Button
                  {...triggerProps}
                  iconBefore={
                    <ArrowDownIcon label="Restore Issues" size="medium" />
                  }
                  appearance="default"
                  isSelected={isOpen}
                  isDisabled={
                    props.isLoading || props.checkedIssues.length === 0
                  }
                  onClick={() => setIsOpen(!isOpen)}
                >
                  Download Data
                </Button>
              )}
            />
            <Button
              iconBefore={
                <BitbucketCloneIcon label="Restore Issues" size="medium" />
              }
              appearance="primary"
              id="restoreIssues"
              onClick={() => props.setShowConfirmation(true)}
              isDisabled={
                props.isLoading ||
                props.checkedIssues.length === 0 ||
                props.checkedIssues.length > 50
              }
            >
              Restore Issues
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default RestorePreview;
